import script from "./PwzrDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PwzrDetail.vue?vue&type=script&setup=true&lang=js"

import "./PwzrDetail.vue?vue&type=style&index=0&id=03ddf5d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ddf5d9"]])

export default __exports__